export enum KsefConfigurationStatus {
	INACTIVE = "INACTIVE",
	OK = "OK",
	INFO_WARNING = "INFO_WARNING",
	ERROR = "ERROR",
	INFO = "INFO",
	INFO_ERROR = "INFO_ERROR",
	WARNING = "WARNING",
	BLOCKED = "BLOCKED",
}